export const useStyles = () => {
    return {
        container: {
            display: 'flex',
            flexDirection: 'column',
            height: 'calc(100% - 24px)',
            '& .table-container.table-container': {
                maxHeight: 'calc(90vh - 300px)'
            },
            gap: 3
        },
        tableHeader: {
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            width: '100%',
            justifyContent: 'space-between'
        },
        actionHeader: {
            display: 'flex',
            alignItems: 'center',
        },
        switch: {
            gap: 1,
            '& .MuiFormControlLabel-label': {
                fontSize: '14px',
                color: 'c_grey.100',
                width: 'max-content'
            }
        },
        paperRoot: {
            padding: 3
        }
    }
}